import { z } from 'zod'

/**
 * Public build-time configuration. Everything here ends up in the browser
 * bundle, so it must never contain secrets.
 */
const schema = z.object({
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(20),
  VITE_TURNSTILE_SITE_KEY: z.string().default(''),
  VITE_RAZORPAY_ENABLED: z
    .enum(['true', 'false'])
    .default('false')
    .transform((v) => v === 'true'),
})

const parsed = schema.safeParse(import.meta.env)

export const envError = parsed.success ? null : parsed.error
export const env = parsed.success
  ? parsed.data
  : {
      VITE_SUPABASE_URL: 'http://127.0.0.1:54321',
      VITE_SUPABASE_ANON_KEY: 'missing',
      VITE_TURNSTILE_SITE_KEY: '',
      VITE_RAZORPAY_ENABLED: false,
    }
